import { useIsPromotionBannerDisabled } from './useIsPromotionBannerDisabled';
import { usePageChrome } from './usePageChrome';

/**
 * Whether promo (CMS campaign) coupons count on this page: only where the promo banner is shown,
 * never on routes that hide it (e.g. TOTW) or when the promotion-banner A/B test disables it.
 */
export const useIncludePromoCoupons = () => {
  const { hidePromoBanner } = usePageChrome();
  const isPromotionBannerDisabled = useIsPromotionBannerDisabled();
  return !hidePromoBanner && !isPromotionBannerDisabled;
};
